import React from "react";
import { Link } from "react-router-dom";
import { Frame } from "lucide-react";

const COLS = [
  {
    title: "Calculator",
    links: [
      { to: "/calculator", label: "Frame & mat calculator" },
      { to: "/pricing", label: "Pricing & plans" },
      { to: "/contact", label: "Contact us" },
    ],
  },
  {
    title: "Guides",
    links: [
      { to: "/framing-tips", label: "Framing tips & tricks" },
      { to: "/mat-cutting-tips", label: "Mat cutting tips" },
      { to: "/aesthetics", label: "Frame & mat aesthetics" },
    ],
  },
];

export function SiteFooter() {
  return (
    <footer className="border-t border-border bg-secondary/40">
      <div className="mx-auto grid max-w-7xl grid-cols-2 gap-8 px-4 py-12 sm:px-6 md:grid-cols-4 lg:px-8">
        <div className="col-span-2 md:col-span-2">
          <Link to="/" className="flex items-center gap-2.5">
            <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary text-primary-foreground">
              <Frame className="h-5 w-5" />
            </div>
            <span className="font-heading text-lg font-extrabold tracking-tight">Framer's Bench</span>
          </Link>
          <p className="mt-4 max-w-sm text-sm leading-relaxed text-muted-foreground">
            A precision frame and mat calculator for artists, photographers, framers and studios. Get the exact mat
            borders, matboard cut sizes, glass and frame dimensions — so your work fits the first time.
          </p>
        </div>
        {COLS.map((c) => (
          <div key={c.title}>
            <h3 className="mb-3 text-xs font-semibold uppercase tracking-[0.08em] text-muted-foreground">{c.title}</h3>
            <ul className="space-y-2.5">
              {c.links.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-sm text-foreground/80 transition-colors hover:text-primary">{l.label}</Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="border-t border-border">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-2 px-4 py-5 text-xs text-muted-foreground sm:flex-row sm:px-6 lg:px-8">
          <p>© {new Date().getFullYear()} Framer's Bench. All rights reserved.</p>
          <p>Built for artists, framers &amp; makers everywhere.</p>
        </div>
      </div>
    </footer>
  );
}
